import guifoScreen from './../../../assets/images/projectsScreens/screens/guifos.png';
import mixamoBg from './../../../assets/images/projectsScreens/screens/mixamo.png';

const images = {
    guifoScreen, mixamoBg
};

export default images;